import React from "react";
import {HomeView} from "../views/homeView.js";
import { userModel } from "../index.js";

function Home(props) {
  userModel.shuffleInstructions();
  return React.createElement(HomeView, {
    onStart: () => props.history.push("/test")});
}

export default Home;